const freeSampleProductsNetSuiteMapping = {
  "quick-dna-miniprep-plus-dna-extraction-kit": { netSuiteId: "7372"},
  "quick-dna-fungal-bacterial-miniprep-kit": { netSuiteId: "7923"},
  "quick-dna-plant-seed-miniprep-kit": { netSuiteId: "10036"},
  "quick-dna-fecal-soil-microbe-dna-miniprep-kit": { netSuiteId: "7935"},
  "zymopure-ii-plasmid-miniprep-kit": { netSuiteId: "7516"},
  "zymopure-ii-plasmid-midiprep-kit": { netSuiteId: "7507"},
  "zymopure-ii-plasmid-maxiprep-kit": { netSuiteId: "7511"},
  "zyppy-plasmid-miniprep-kit": { netSuiteId: "7307"},
  "direct-zol-rna-microprep-kits": { netSuiteId: "8556"},
  "direct-zol-rna-miniprep-kits": { netSuiteId: "8551"},
  "quick-rna-microprep-kit": { netSuiteId: "18398"},
  "quick-rna-miniprep-kit": { netSuiteId: "8396"},
  "quick-rna-miniprep-plus-kit": { netSuiteId: "8400"},
  "quick-rna-viral-kit": { netSuiteId: "19733"},
  "dna-clean-concentrator-5": { netSuiteId: "7194"},
  "rna-clean-concentrator-5": { netSuiteId: "8347"},
  "genomic-dna-clean-concentrator-10": { netSuiteId: "7210"},
  "onestep-pcr-inhibitor-removal-new-kit": { netSuiteId: "19231"},
  "select-a-size-dna-clean-concentrator-magbead-kit": { netSuiteId: "7428"},
  "zymoclean-gel-dna-recovery-kit": { netSuiteId: "7170"},
  "zymobiomics-dna-miniprep-kit": { netSuiteId: "7542"},
  "zymobiomics-dna-rna-miniprep-kit": { netSuiteId: "8532"},
  "zymobiomics-rna-miniprep-kit": { netSuiteId: "8530"},
  "ez-dna-methylation-lightning-kit": { netSuiteId: "7712"},
  "dna-rna-shield": { netSuiteId: "8459"},
  "urine-conditioning-buffer": { netSuiteId: "14178"},
  // "dna-rna-shield-fecal-collection-tube": { netSuiteId: "8463"},
  // "dna-rna-shield-fecal-collection-tube": { netSuiteId: "21067"},
  "bunny-wipe-fecal-sample-collector": { netSuiteId: "21070"},
  "dna-rna-shield-collection-tube-w-swab": { netSuiteId: "8476"},
  "dna-rna-shield-blood-collection-tube": { netSuiteId: "8501"},
  "dna-rna-shield-fecal-collection-kit": { netSuiteId: "21068"},
  "dna-rna-shield-safecollect-swab-collection-kit": { netSuiteId: "21092"},
  "dna-rna-shield-safecollect-saliva-collection-kit": { netSuiteId: "18567"},
  // "dna-rna-shield-lysis-and-collection-tubes": { netSuiteId: "8467"},
  // "dna-rna-shield-lysis-and-collection-tubes": { netSuiteId: "8471"},
  // "dna-rna-shield-lysis-and-collection-tubes": { netSuiteId: "8473"},
  // "dna-rna-shield-lysis-and-collection-tubes": { netSuiteId: "8474"},
  "mix-and-go-competent-cells-dh5-alpha": { netSuiteId: "12889"},
  "zymolyase-ultra": { netSuiteId: "20467"},
  "dnase-i-set": { netSuiteId: "19722"},
  "purerec-rnase-a-recombinant": { netSuiteId: "20263"},
  "purerec-duplex-specific-nuclease-dsn": { netSuiteId: "20482"}
  }